import store from "@/store";
const LOGIN_PAGE_NAME = "login";
const NOTFOUND_PAGE = "error_404";
const ROOT_PAGE_NAME = "root";

export const addQueryGroupNameMiddleware = async (to, from) => {
    try {
        // 配置filter群組路由
        if (to.name == NOTFOUND_PAGE)
            return {
                nextOption: {}
            };
        const { inGroupNames } = store.getters;
        const toQueryGroupName = to.query.groupName;
        // 注意state.queryGroupName不取變數, 因為值有可能更改, 先獲取的變數不會跟著改變
        // 如果有給query
        if (toQueryGroupName) {
            // console.log(`Detect given ${toQueryGroupName}`);
            if (toQueryGroupName && toQueryGroupName !== store.state.queryGroupName) {
                if (inGroupNames.includes(toQueryGroupName)) {
                    // console.log(`${toQueryGroupName} different from store`);
                    // console.log(`${toQueryGroupName} is valid, commit to store`);
                    store.commit("SET_QUERY_GROUPNAME", toQueryGroupName);
                    return {
                        nextOption: {}
                    };
                } else {
                    // console.log(`${toQueryGroupName} is NOT valid, use store state`);
                    return {
                        nextOption: { path: to.path, query: { ...to.query, groupName: store.state.queryGroupName } }
                    };
                }
            } else {
                // console.log(`${toQueryGroupName}, same as store, nothing to do`);
                return {
                    nextOption: {}
                };
            }
        } else {
            // 路由未帶query
            if (store.getters.getQueryGroupName == "" && store.getters.isAdmin) {
                // console.log("admin且沒帶query")
                store.commit("SET_QUERY_GROUPNAME", store.getters.inGroupNames.length > 0 ? store.getters.inGroupNames[0] : "all");
            }
            if (store.getters.getQueryGroupName == "" && !store.getters.isAdmin) {
                // console.log("nuser且沒帶query")
                store.commit("SET_QUERY_GROUPNAME", store.getters.inGroupNames[0]);
            }

            return {
                nextOption: { path: to.path, query: { ...to.query, groupName: store.getters.getQueryGroupName } }
            };
        }
    } catch (err) {
        console.log(err);
    }
};



// WEBPACK FOOTER //
// ./src/libs/routerMiddleware/addQueryGroupName.js